/**
 * @fileoverview Capabilities query keys.
 * @description Every Capabilities query sits under the `['capabilities']` prefix so a save or a
 * restore refreshes the matrix in one invalidation.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

export const CAPABILITIES_QUERY_KEY = ['capabilities'] as const

export const CAPABILITIES_QUERY_KEYS = {
  matrix: [...CAPABILITIES_QUERY_KEY, 'matrix'] as const,
}
